import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { EmailService } from '../../../services';

@Component({
    templateUrl: 'email.edit.component.html',
})

export class EmailEditComponent extends DetalheBaseController {

    model: any = {};
    showMsgAdd: boolean = false;

    constructor(route: ActivatedRoute, private _emailService: EmailService) {
        super(route, _emailService);                
    }

    ngOnInit() {         
        if (this.type == "addLogon") {
            this.showMsgAdd = true;
        }
        
        this.showForm = true;        
        this._loading.fecharTodos();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/email/edit/email.edit.component.ts